<ng-container *transloco="let t">
  <app-page-template [isLanding]="true" [isTopBannerVisible]="false">
    <div class="pb-0-50">
      <app-hero-alt>
        <div slot="slotText">
          <div class="pb-3">
            <h1 class="main-hero-title font-6xl light">
              Find the race that <br/> inspires you to move</h1>
          </div>
          <div class="d-flex flex-row d-xxl-none">
            <div class="pe-2 d-inline-flex">
              <app-button-alt [text]="t('page.header.finished.events')" [buttonHeight]="'32px'"
                              (onClickCallback)="goToFinished()" [isFullWidth]="false" [fontSize]="'14px'"
                              [textColor]="'var(--grey-neutral-800)'" [textTransform]="'uppercase'"
                              [buttonColor]="'white'"></app-button-alt>
            </div>
            <app-button-alt [buttonColor]="'var(--red-brand-color-dark)'" [borderColor]="'var(--red-brand-color-dark)'"
                            [textColor]="'var(--grey-neutral-50)'" [text]="t('app.landing.race.calendar')"
                            [buttonHeight]="'32px'" (onClickCallback)="onEventCalendar()" [isFullWidth]="false"
                            [textTransform]="'uppercase'"
                            [fontSize]="'14px'"></app-button-alt>
          </div>
        </div>
        <div slot="slotSearchBar" class="d-none d-xxl-block">
          <div class="d-flex justify-content-start align-items-center pb-5">
            <app-search-bar-events [isTransparent]="true"/>
          </div>
        </div>
      </app-hero-alt>
    </div>
    <div class="container">
      <section class="pb-0-50 pt-30-28">
        <div class="swiper-section-wrapper">
          @if (upcomingItems !== null && upcomingItems.length > 0) {
            <div [class.swiper-placeholder-stack]="isBrowser" [hidden]="swiperReady.upcoming" class="d-sm-none">
              <div class="d-flex justify-content-between align-items-center mb-xl-3">
                <h1 class="h1-subTitle">{{ t('app.landing.upcoming.events') }}</h1>
                <div class="d-flex justify-content-end">
                  <i class="bi bi-chevron-left cursor-pointer disabled"></i>
                  <div class="d-flex align-items-center justify-content-center" style="width: 40px"></div>
                  <i class="bi bi-chevron-right cursor-pointer disabled"></i>
                </div>
              </div>
              <div class="swiper-placeholder">
                <div class="swiper-placeholder__row">
                  <div class="swiper-placeholder__item swiper-placeholder__item--first">
                    <app-event-grid-item [eventItem]="upcomingItems[0]"
                                                        [layout]="CalendarViewType.GRID"
                                                        (onRightButtonClickCallback)="goToEventDetailsPage(upcomingItems[0])"
                                                        [languages]="languages"/>
                  </div>
                  <div class="swiper-placeholder__item">
                    <app-event-grid-item [eventItem]="upcomingItems[1]"
                                                        [layout]="CalendarViewType.GRID"
                                                        (onRightButtonClickCallback)="goToEventDetailsPage(upcomingItems[1])"
                                                        [languages]="languages"/>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (isBrowser) {
            <div [class.invisible]="!swiperReady.upcoming" class="swiper-layer">
              <div class="d-flex justify-content-between align-items-center mb-xl-3">
                <h1 class="h1-subTitle">{{ t('app.landing.upcoming.events') }}</h1>
                <div class="d-flex justify-content-end">
                  <i class="bi bi-chevron-left cursor-pointer"
                     [class.disabled]="isFirstSlideActive(upcomingEventsSwiper)"
                     (click)="slidePrev(upcomingEventsSwiper, 'upcoming')"></i>
                  <div class="d-flex align-items-center justify-content-center" style="width: 40px">
                    <span class="fs-14-18 d-flex d-sm-none">{{ swiperStates.upcoming.currentSlide }} /
                      {{ swiperStates.upcoming.totalSlides }}</span>
                  </div>
                  <i class="bi bi-chevron-right cursor-pointer"
                     [class.disabled]="isLastSlideActive(upcomingEventsSwiper)"
                     (click)="slideNext(upcomingEventsSwiper, 'upcoming')"></i>
                </div>
              </div>
              <div>
                @if (upcomingItems !== null && upcomingItems.length > 0) {
                  <swiper #upcomingEventsSwiper [slidesPerView]="3" [spaceBetween]="40" [breakpoints]="breakpoints"
                          (swiper)="onSwiperReady($event, 'upcoming')">
                    @for (item of upcomingItems; track item.id; let last = $last) {
                      <ng-template swiperSlide>
                        @if (!last) {
                          <div class="grid-wrapper">
                            <app-event-grid-item [eventItem]="item"
                                                 [layout]="CalendarViewType.GRID"
                                                 (onRightButtonClickCallback)="goToEventDetailsPage(item)"
                                                 [languages]="languages"/>
                          </div>

                        } @else {
                          <ng-template [ngTemplateOutlet]="exploreAllTemplate"></ng-template>
                        }
                      </ng-template>
                    }
                  </swiper>
                } @else if (upcomingItems !== null) {
                  <app-empty-state/>
                }
              </div>
            </div>
          } @else {
            @if (ssrDeviceType !== 'MOBILE') {
              <div class="d-flex justify-content-between align-items-center mb-xl-3">
                <h1 class="h1-subTitle">{{ t('app.landing.upcoming.events') }}</h1>
                <div class="d-flex justify-content-end">
                  <i class="bi bi-chevron-left cursor-pointer disabled"></i>
                  <div class="d-flex align-items-center justify-content-center" style="width: 40px"></div>
                  <i class="bi bi-chevron-right cursor-pointer disabled"></i>
                </div>
              </div>
              <div class="row gutter-x-0 flex-nowrap overflow-hidden">
                @for (item of upcomingItems; track item.id; let last = $last) {
                  @if (!last) {
                    <div class="col-4 grid-wrapper">
                      <app-event-grid-item [eventItem]="item"
                                                          [layout]="CalendarViewType.GRID"
                                                          (onRightButtonClickCallback)="goToEventDetailsPage(item)"
                                                          [languages]="languages"/>
                    </div>
                  } @else {
                    <div class="col-4 p-0">
                      <ng-template [ngTemplateOutlet]="exploreAllTemplate"></ng-template>
                    </div>
                  }
                }
              </div>
            } @else {
              @if (upcomingItems !== null && upcomingItems.length === 0) {
                <app-empty-state/>
              }
            }
          }
        </div>
      </section>
    </div>

    <section class="pb-80-28 pt-30-28">
      <div class="container">
        <div class="swiper-section-wrapper">
          @if (newItems !== null && newItems.length > 0) {
            <div [class.swiper-placeholder-stack]="isBrowser" [hidden]="swiperReady.newEvents" class="d-sm-none">
              <div class="d-flex justify-content-between align-items-center mb-xl-3">
                <h1 class="h1-subTitle">{{ t('app.landing.new.events') }}</h1>
                <div class="d-flex">
                  <i class="bi bi-chevron-left cursor-pointer disabled"></i>
                  <div class="d-flex align-items-center justify-content-center" style="width: 40px"></div>
                  <i class="bi bi-chevron-right cursor-pointer disabled"></i>
                </div>
              </div>
              <div class="swiper-placeholder">
                <div class="swiper-placeholder__row">
                  <div class="swiper-placeholder__item swiper-placeholder__item--first">
                    <app-event-grid-item [eventItem]="newItems[0]"
                                                        [layout]="CalendarViewType.GRID"
                                                        (onRightButtonClickCallback)="goToEventDetailsPage(newItems[0])"
                                                        [languages]="languages"/>
                  </div>
                  <div class="swiper-placeholder__item">
                    <app-event-grid-item [eventItem]="newItems[1]"
                                                        [layout]="CalendarViewType.GRID"
                                                        (onRightButtonClickCallback)="goToEventDetailsPage(newItems[1])"
                                                        [languages]="languages"/>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (isBrowser) {
            <div [class.invisible]="!swiperReady.newEvents" class="swiper-layer">
              <div class="d-flex justify-content-between align-items-center mb-xl-3">
                <h1 class="h1-subTitle">{{ t('app.landing.new.events') }}</h1>
                <div class="d-flex">
                  <i class="bi bi-chevron-left cursor-pointer" [class.disabled]="isFirstSlideActive(newEventsSwiper)"
                     (click)="slidePrev(newEventsSwiper, 'newEvents')"></i>
                  <div class="d-flex align-items-center justify-content-center" style="width: 40px">
                    <span class="fs-14-18 d-flex d-sm-none">{{ swiperStates.newEvents.currentSlide }} /
                      {{ swiperStates.newEvents.totalSlides }}</span>
                  </div>
                  <i class="bi bi-chevron-right cursor-pointer" [class.disabled]="isLastSlideActive(newEventsSwiper)"
                     (click)="slideNext(newEventsSwiper, 'newEvents')"></i>
                </div>
              </div>
              <div>
                @if (newItems !== null && newItems.length > 0) {
                  <swiper #newEventsSwiper [slidesPerView]="3" [spaceBetween]="40" [breakpoints]="breakpoints"
                          (swiper)="onSwiperReady($event, 'newEvents')">
                    @for (item of newItems; track item.id; let last = $last) {
                      <ng-template swiperSlide>
                        @if (!last) {
                          <div class="grid-wrapper">
                            <app-event-grid-item [eventItem]="item"
                                                              [layout]="CalendarViewType.GRID"
                                                              (onRightButtonClickCallback)="goToEventDetailsPage(item)"
                                                              [languages]="languages"/>
                          </div>
                        } @else {
                          <ng-template [ngTemplateOutlet]="exploreAllTemplate"></ng-template>
                        }
                      </ng-template>
                    }
                  </swiper>
                } @else if (newItems !== null) {
                  <app-empty-state/>
                }
              </div>
            </div>
          } @else {
            @if (ssrDeviceType !== 'MOBILE') {
              <div class="d-flex justify-content-between align-items-center mb-xl-3">
                <h1 class="h1-subTitle">{{ t('app.landing.new.events') }}</h1>
                <div class="d-flex">
                  <i class="bi bi-chevron-left cursor-pointer disabled"></i>
                  <div class="d-flex align-items-center justify-content-center" style="width: 40px"></div>
                  <i class="bi bi-chevron-right cursor-pointer disabled"></i>
                </div>
              </div>
              <div class="row gutter-x-0 flex-nowrap overflow-hidden">
                @for (item of newItems;track item.id;let last = $last) {
                  @if (!last) {
                    <div class="col-4 pe-3">
                      <app-event-grid-item [eventItem]="item"
                                                          [layout]="CalendarViewType.GRID"
                                                          (onRightButtonClickCallback)="goToEventDetailsPage(item)"
                                                          [languages]="languages"/>
                    </div>
                    <div class="col-4 p-0">
                      <ng-template [ngTemplateOutlet]="exploreAllTemplate"></ng-template>
                    </div>
                  }
                }
              </div>
            } @else {
              @if (newItems !== null && newItems.length === 0) {
                <app-empty-state/>
              }
            }
          }
        </div>
      </div>
    </section>

    @if (currentWindowWidth > 991) {
      <section class="your-sport-container container-fluid pb-80-28">
        <div class="d-flex flex-column align-items-center pt-65-45">
          <h1>Trace Your Tracks</h1>
          <p class="regular">
            Choose your sport and take the first step toward your goals. </p>
        </div>

        <div class="container">
          <div class="d-flex justify-content-center flex-column">
            <div class="d-flex justify-content-center flex-column flex-md-row">
              @for (sport of sports; track sport) {
                @if (sport.imgSrc) {
                  <div class="d-flex flex-column justify-content-center align-items-center"
                       [ngClass]="{'pe-4-5': sports.indexOf(sport) !== sports.length - 2}">
                    <div class="sport-icon-wrapper">
                      <img [src]="sport.imgSrc" alt="{{ t(sport.buttonTextKey) }}" height="64" width="64">
                    </div>
                    <div class="d-flex flex-column align-items-center">
                      <app-button-alt [text]="t(sport.buttonTextKey)" (onClickCallback)="explore(sport.id)"
                                      [borderColor]="'var(--teal-500)'" [textColor]="'var(--grey-neutral-800)'"
                                      [buttonColor]="'transparent'" [minWidth]="'180px'"/>
                    </div>
                  </div>
                }
              }
            </div>
            <div>
              @for (sport of sports; track sport; let last = $last) {
                @if (!sport.imgSrc) {
                  <div class="d-flex flex-column justify-content-center align-items-center pt-4">
                    <app-button-alt [text]="t(sport.buttonTextKey)" [borderColor]="'var(--teal-500)'"
                                    [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="explore(sport.id)"
                                    [buttonColor]="'transparent'"
                                    [trailingIcon]="'assets/icons/icons-alt/chevron_down.svg'" [minWidth]="'180px'"/>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </section>
    } @else {
      <section class="your-sport-container--mobile py-4">
        <div class="d-flex flex-column align-items-center">
          <h2 class="fw-medium">Trace Your Tracks</h2>
          <p class="regular small pt-2">
            Choose your sport and take the first step toward your goals. </p>
        </div>
        <div class="container">
          <div class="sports-grid pt-4 pb-3">
            @for (sport of sports; track sport; let last = $last) {
              @if (sport.imgSrc) {
                <div class="sport-item py-2 px-2" (click)="explore(sport.id)">
                  <div class="">
                    <img [src]="sport.imgSrc" alt="{{ t(sport.buttonTextKey) }}" height="44" width="44">
                  </div>
                  <div class="d-flex flex-column align-items-center justify-content-center trim-text">
                    <span class="text-uppercase fs-14 text-center trim-text sport-label">{{
                        t(sport.buttonTextKey)
                      }}</span>
                  </div>
                </div>
              }
            }
          </div>
          <div class="d-flex align-items-center justify-content-center">
            @for (sport of sports; track sport; let last = $last) {
              @if (!sport.imgSrc) {
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <app-button-alt [text]="t(sport.buttonTextKey)" [borderColor]="'var(--teal-500)'"
                                  [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="explore(sport.id)"
                                  [buttonColor]="'transparent'"
                                  [trailingIcon]="'assets/icons/icons-alt/chevron_down.svg'"
                                  [additionalClass]="'pe-2'"/>
                </div>
              }
            }
          </div>
        </div>
      </section>
    }
  </app-page-template>

  <!-- Explore All Template -->
  <ng-template #exploreAllTemplate>
    <div class="explore-all">
      <app-button-alt [buttonColor]="'var(--red-brand-color-500)'"
                      [borderColor]="'var(--red-brand-color-500)'" [textColor]="'var(--grey-neutral-50)'"
                      [text]="t('app.landing.explore.all')" (onClickCallback)="exploreAll()"
                      [buttonHeight]="'48px'"></app-button-alt>
    </div>
  </ng-template>

</ng-container>


